import { Injectable, signal } from '@angular/core';

/** Short feedback for mock actions in the customer portal. */
@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly message = signal<string | null>(null);
  private timer?: ReturnType<typeof setTimeout>;

  show(text: string): void {
    this.message.set(text);
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.message.set(null), 3500);
  }

  /** For actions that call the backend later. */
  mock(text: string): void {
    this.show(`${text} (prototype: no backend action performed)`);
  }
}
